import { appApiSlice } from "src/api/app-ApiSlice";

export interface CreatePostItRequest {
    x?: number;
    y?: number;
    color: string;
    note: string;
    floor_id: number;
    note_type: number;
    plan_object_id?: number;
}

export interface CreatePostItResponse {
    message: string;
    id: number;
}

export interface UpdatePostItRequest {
    post_it_id: number;
    color: string;
    note: string;
    x?: number;
    y?: number;
}

export interface UpdatePostItResponse {
    message: string;
}

export const postitsApiSlice = appApiSlice.injectEndpoints({
    endpoints: (builder) => ({
        createPostIt: builder.mutation<CreatePostItResponse, CreatePostItRequest>({
            query: (payload) => ({
                url: `/v1/postits`,
                method: 'POST',
                body: payload,
            }),
        }),
        updatePostIt: builder.mutation<UpdatePostItResponse, UpdatePostItRequest>({
            query: (payload) => ({
                url: `/v1/postits`,
                method: 'PUT',
                body: payload,
            }),
        }),
    }),
    overrideExisting: false,
});

export const { useCreatePostItMutation, useUpdatePostItMutation } = postitsApiSlice;